import { CheckOutlined, CloseOutlined } from '@mui/icons-material'
import { AIModelType } from '@tabeeb/contracts/main-api/swagger-main-api'

export const boolToText = (flag: boolean): string => (flag ? 'On' : 'Off')
export const boolToIcon = (flag: boolean) =>
  flag ? <CheckOutlined color='success' /> : <CloseOutlined color='error' />

export const isAIModelWithKey = (aiModelType: AIModelType): boolean => {
  switch (aiModelType) {
    case AIModelType.External:
    case AIModelType.CustomVision:
    case AIModelType.HuggingFace:
    case AIModelType.Roboflow:
      return true
    default:
      return false
  }
}

export const isAIModelKeyRequired = (aiModelType: AIModelType): boolean => {
  switch (aiModelType) {
    case AIModelType.CustomVision:
    case AIModelType.HuggingFace:
    case AIModelType.Roboflow:
      return true
    case AIModelType.External:
    default:
      return false
  }
}

export const getAIModelKeyName = (aiModelType: AIModelType): string => {
  switch (aiModelType) {
    case AIModelType.CustomVision:
      return 'Prediction Key'
    case AIModelType.Roboflow:
      return 'Private API Key'
    case AIModelType.HuggingFace:
    case AIModelType.External:
    default:
      return 'Token'
  }
}

export const isAIModelUrlDisplayed = (aiModelType: AIModelType): boolean => {
  return aiModelType !== AIModelType.InternalTrained
}

export const isOnlyAIObjectsOfParentAllowed = (aiModelType: AIModelType): boolean => {
  return aiModelType === AIModelType.InternalTrained
}
